<ng-container *ngIf="loading$ | async; else taxMapper">
  <p class="text-center w-full py-16"><em>Tax rates are loading</em></p>
</ng-container>

<ng-template #taxMapper>
  <div
    fxLayout="column"
    fxLayoutGap="12px"
    fxFlexfill
    *ngIf="optionsByTaxType$ | async as optionsByTaxType"
  >
    <div
      class="flex flex-col my-8 md:flex-row md:my-3 md:justify-between md:items-center w-full"
      *ngFor="let formGroup of form.controls; let i = index"
      [formGroup]="formGroup"
    >
      <p>
        <strong
          >{{ formGroup.value.name }} -
          {{ formGroup.value.value * 100 }}%</strong
        >
      </p>

      <mat-form-field>
        <mat-label>{{ integration$ | async | titlecase }} Tax Rate</mat-label>
        <mat-select formControlName="reference">
          <mat-option
            *ngFor="let taxRate of optionsByTaxType[formGroup.value.type]"
            [value]="taxRate.tax_id"
          >
            {{ taxRate.tax_name }} - {{ taxRate.tax_percentage }}%
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</ng-template>
